import type { PropsWithChildren } from 'react';
import React from 'react';
import * as styles from '../css/category.css';
import { classNames } from '../utils';

interface Props {
    children: React.ReactNode;
    className?: string;
    standalone?: boolean;
}

const Category = ({ children, className, standalone }: PropsWithChildren<Props>) => (
    <div className={classNames(styles.root, className, standalone && styles.standalone)}>
        {children}
    </div>
);

export default Category;
